import { FormControl, FormHelperText, Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import { Link, useNavigate } from 'react-router-dom';

import { GridDeleteIcon } from '@mui/x-data-grid';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import configUrls from '../../../config/configUrls';
import { ProcessoBloco } from '../../../types/processo/ProcessoBloco';
import { Usuario } from '../../../types/usuario/Usuario';

import TxtBloco from '../../autoComplete/TxtBloco';
import { Bloco } from '../../../types/bloco/Bloco';

type Props = {
  data: ProcessoBloco;
  isdisabled?: boolean;
  handleSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handletxtBlocoChange: (value: Bloco) => void;
  blocoValueTmp: Bloco;
};

export function ProcessoBlocoForm({ data, isdisabled = false, handleSubmit, handleChange, handletxtBlocoChange, blocoValueTmp }: Props) {
  const navigate = useNavigate();
  const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);

  useEffect(() => {
    if (!processoSelecionado) {
      navigate(configUrls.PROCESSO_LIST_RT);
    }
  }, [processoSelecionado, navigate]);

  return (
    <Box mt={2} p={2}>
      <form onSubmit={handleSubmit} method="POST">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between" gap={2}>
              <FormControl fullWidth>
                <TxtBloco
                  value={blocoValueTmp}
                  handleSearchChange={it => {
                    handletxtBlocoChange(it);
                  }}
                />
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                id="observacoes-unidade"
                label="Observação:"
                name="observacao"
                disabled={isdisabled}
                onChange={handleChange}
                size="small"
                multiline
                rows={4}
                inputProps={{ maxLength: 255 }}
                value={data.observacao}
                placeholder="Digite aqui sua observação..."
              />
              <FormHelperText>{data.observacao?.length}/255 caracteres</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" gap={2}>
              <Button type="submit" variant="contained" color="primary" disabled={isdisabled}>
                Gravar
              </Button>

              <Button variant="contained" onClick={() => navigate(-1)} color="secondary">
                Voltar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
